import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiService } from '../../services/api';
import AdminLayout from '../../components/admin/AdminLayout';
import ProductForm from '../../components/admin/ProductForm';
import styles from './AdminProducts.module.css';

const EditProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    // Obtener datos del producto
    apiService.getProduct(id)
      .then(data => setProduct(data))
      .catch(() => setError('No se pudo cargar el producto'));
    // Obtener categorías
    apiService.getCategories()
      .then(data => setCategories(Array.isArray(data) ? data : data.categories || []))
      .catch(() => setCategories([]))
      .finally(() => setLoading(false));
  }, [id]);

  const handleProductUpdated = (updatedProduct) => {
    setProduct(updatedProduct);
    // Puedes mostrar un mensaje de éxito aquí
  };

  const handleDelete = async () => {
    if (!window.confirm('¿Seguro que deseas borrar este producto?')) return;
    try {
      const res = await fetch(`http://localhost:3001/api/products/${id}`, {
        method: 'DELETE',
      });
      if (!res.ok) throw new Error('Error al borrar el producto');
      navigate('/admin/products');
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <AdminLayout><div>Cargando...</div></AdminLayout>;
  if (error) return <AdminLayout><div className={styles.error}>{error}</div></AdminLayout>;

  return (
    <AdminLayout>
      <div className={styles.productManagement}>
        <div className={styles.header}>
          <h1>Editar Producto</h1>
          <button className={styles.deleteButton} onClick={handleDelete}>🗑️ Borrar producto</button>
        </div>
        <ProductForm
          categories={categories}
          product={product}
          onProductCreated={handleProductUpdated}
        />
      </div>
    </AdminLayout>
  );
};

export default EditProduct;
